import React from "react";
import { css } from "@emotion/react";
import { mq } from "@/constants/breakpoints";
import { darkColor } from "@/constants/colors";
import { gotham } from "@/utils/fonts";
import { Heading } from "../Typography";

interface MobilePricingSummaryProps {
  isAnnual: boolean;
  pricingPlans?: Array<{
    name: string;
    monthlyPrice: number;
    annualPrice: number;
    annualPricePerMonth: number;
  }>;
}

const MobilePricingSummary: React.FC<MobilePricingSummaryProps> = ({
  isAnnual,
  pricingPlans,
}) => {
  // Ensure we have exactly 3 pricing plans or use defaults
  const plans = pricingPlans?.slice(0, 3) || [
    {
      name: "Basic",
      monthlyPrice: 44,
      annualPrice: 348,
      annualPricePerMonth: 29,
    },
    {
      name: "Plus",
      monthlyPrice: 74,
      annualPrice: 588,
      annualPricePerMonth: 49,
    },
    {
      name: "Pro",
      monthlyPrice: 124,
      annualPrice: 1068,
      annualPricePerMonth: 89,
    },
  ];

  return (
    <div
      className={gotham.className}
      css={css`
        display: flex;
        flex-direction: column;
        width: 100%;
        border: 2px solid #daf2ff;
        border-radius: 15px;
        background: #fff;
        overflow: hidden;
        margin-top: 60px;
        margin-bottom: 16px;

        ${mq["lg"]} {
          display: none;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: space-between;
        `}
      >
        {plans.map((plan, index) => (
          <div
            key={plan.name}
            css={css`
              display: flex;
              flex-direction: column;
              align-items: center;
              flex: 1;
              padding: 16px;
              ${mq["sm"]} {
                padding: 20px;
              }
              ${index > 0 ? "border-left: 2px solid #daf2ff;" : ""}
            `}
          >
            <Heading
              level={5}
              css={css`
                color: ${darkColor};
                text-align: center;
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 130.023%; /* 23.404px */
              `}
            >
              {plan.name}
            </Heading>
            <div
              css={css`
                display: flex;
                align-items: flex-end;
              `}
            >
              <span
                css={css`
                  color: ${darkColor};
                  margin-top: 6px;
                  line-height: 1;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 130.023%;
                `}
              >
                ${isAnnual ? plan.annualPricePerMonth : plan.monthlyPrice}
              </span>
              <span
                className={gotham.className}
                css={css`
                  color: ${darkColor};
                  margin-left: 2px;
                  margin-bottom: 2px;
                  font-size: 10px;
                  font-style: normal;
                  font-weight: 350;
                  line-height: normal;
                  white-space: nowrap;
                `}
              >
                / mo
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobilePricingSummary;
